import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/auditLogs/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/auditLogs/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/auditLogs/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/auditLogs/delete',
    method: 'post',
    data
  })
}

